import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {CHART_TYPE, DataBase, TUPLA_TYPE} from './data-base';
import {DataTuplaDescription} from './data-tupla-description';
import {DataRow} from './data-row';
import {DataSeries} from './data-series';
import {el} from '@angular/platform-browser/testing/src/browser_util';
import {DataTupla} from './data-tupla';

@jsonObject
export class DataGrid extends DataBase {
  @jsonMember
  description = 'description';
  @jsonArrayMember(DataTuplaDescription)
  tuplasDescription: DataTuplaDescription[];
  @jsonArrayMember(DataRow)
  gwtRows: DataRow[];
  @jsonArrayMember(String)
  notes: string[];
  @jsonMember
  private defaultChartType: string;

  public get DefaultChartType(): CHART_TYPE {
    return CHART_TYPE[this.defaultChartType];
  }

  public get DataRows(): DataRow[] {
    return this.gwtRows;
  }

  public get Notes(): string[] {
    return this.notes;
  }
  /**
   * Get row by id
   * @param rowId ror to find
   * @return undefined if not found
   */
  public getDataRow(rowId: string): DataRow {
    return this.DataRows.find(x => x.Id === rowId);
  }

  // Utilities

  /**
   * Get all visible tuplas from specific row
   * @param rowIdx 0 based
   */
  public getRowDataTuplaDescriptionVisible(rowIdx: number): DataTupla[] {
    if (rowIdx >= this.DataRows.length) {
      console.error('Requested rowIdx ' + rowIdx + ' in table with ' + this.DataRows.length + ' rows');
      return [];
    }

    const dataRow = this.DataRows[rowIdx];
    const columnsVisible = this.getColumnsVisible();
    return dataRow.DataTuplas.filter(dataTuplas => {
      if (columnsVisible.find( id => id === dataTuplas.Id) !== undefined) {
        return true;
      } else {
        return false;
      }
    });
  }
  /**
   * Get all tuplas descrition visible
   */
  public getTuplasDescriptionVisible(): DataTuplaDescription[] {
    const result = this.tuplasDescription.filter(dataTuplaDescription => dataTuplaDescription.visible === true);
    return result;
  }
  public setAllColumnsInvisible(): void {
    this.tuplasDescription.forEach(dataTuplaDescription => dataTuplaDescription.visible = false);
  }
  public setColumnsVisible(columnIdList: string[]): void {
    this.tuplasDescription.forEach(dataTuplaDescription => {
      if (columnIdList.find(x => x === dataTuplaDescription.Id) === undefined) {
        dataTuplaDescription.visible = false;
      } else {
        dataTuplaDescription.visible = true;
      }
    });
  }
  public getColumnsVisible(): string[] {
    const result: string[] = [];

    this.tuplasDescription.forEach(dataTuplaDescription => {
      if (dataTuplaDescription.visible) {
        result.push(dataTuplaDescription.Id);
      }
    });
    return result;
  }
  /**
   * Select a row and unselect others
   * @param rowId row id. If doesn't exist nothing append
   */
  public selectRowMutex(rowId: string): void {
    // check if row exist
    if (this.getDataRow(rowId) === undefined) {
      console.error('Row ' + rowId + 'not found in table ' + this.Id);
      return;
    }

    // @ts-ignore
    for (const dataRow: DataRow of this.DataRows) {
      dataRow.selected = dataRow.Id === rowId ? true : false;
      }
    }

  /**
   * Select all rows contained into the list. Id not contained into the list are set to unselected
   * @param idsRow list of id row to select
   */
  public selectRows(idsRow: string[]): void {
    this.DataRows.forEach((dataRow) => {
      // check if preset into the list
      dataRow.selected = idsRow.find(x => x === dataRow.Id) === undefined ? false : true;
    });
    }
  /**
   * Select all selectable rows
   */
  public selectAllRows(): void {
    this.DataRows.forEach( dataRow => {
        dataRow.selected = true;
    });
  }

  public rowsSelected2Series(reverse: boolean, columnIds: string[] = null, invertColumnsRows: boolean = false): DataSeries[] {
    const rowIds: string[] = [];

    // get selected rows
    this.DataRows.forEach(dataRow => {
      if (dataRow.selected) {
        rowIds.push(dataRow.Id);
      }
    });

    return this.rows2Series(rowIds, columnIds, reverse, invertColumnsRows);
  }
  public rows2Series(rowIds: string[], columnIds: string[], reverse: boolean, invertColumnsRows: boolean = false): DataSeries[] {
    const datasSeries: DataSeries[] = [];

    let rowsFiltered: DataRow[] = [];

    rowsFiltered = rowIds !== null ? this.DataRows.filter((src) => {
      return rowIds.find(value => value === src.Id) !== undefined ? true : false;
    }) : this.DataRows;


    // set column description. Get only NUMBER type and filter them by columnIds if any
    const tuplasDescription: DataTuplaDescription[] = this.tuplasDescription.filter((tuplaSecription) => {
      // is not number: skip
      if (tuplaSecription.Type !== TUPLA_TYPE.NUMBER) {
        return false;
      }

      // no column filter
      if (columnIds === null || columnIds.length === 0) {
        return true;
      }

      // filter column
      return columnIds.find(value => value === tuplaSecription.Name) !== undefined ? true : false;
    });


    if (invertColumnsRows) {
      // loop for all columns
      tuplasDescription.forEach( (dataTuplaDescription) => {
        const dataSeries: DataSeries = new DataSeries();

        dataSeries.Description = dataTuplaDescription.Name;

        // loop for all rows
        rowsFiltered.forEach( (dataRowSrc) => {
          // set unit to series. At the and series contain unit of last row analyzed
          dataSeries.Units = dataRowSrc.Units;


          // add tupla description to series
          const tuplaDescription = new DataTuplaDescription();
          tuplaDescription.Name = dataRowSrc.Description;
          dataSeries.TuplasDescription.push(tuplaDescription);


          const tupla: DataTupla = dataRowSrc.getDataTupla(dataTuplaDescription.Name);
          if (tupla === undefined) {
            console.error('Tupla ' + dataTuplaDescription.Name + ' not found in row ' + dataRowSrc.Id);
          } else {
            const dataRowNew: DataRow = new DataRow();

            let tuplaNew: DataTupla;

            tuplaNew = new DataTupla();
            tuplaNew.setValue(dataRowSrc.Description, TUPLA_TYPE.STRING);
            dataRowNew.DataTuplas.push(tuplaNew);

            tuplaNew = new DataTupla();
            tuplaNew.setValue(tupla.Value, TUPLA_TYPE.NUMBER);
            tuplaNew.OutputFormat = tupla.OutputFormat;
            dataRowNew.DataTuplas.push(tuplaNew);

            dataSeries.DataRows.push(dataRowNew);
          }
        });

        datasSeries.push(dataSeries);
      });
    } else {
      // loop for all rows
      rowsFiltered.forEach( (dataRowSrc) => {
        const dataSeries: DataSeries = new DataSeries();

        dataSeries.Description = dataRowSrc.Description;
        dataSeries.Units = dataRowSrc.Units;


        dataSeries.TuplasDescription = reverse ? tuplasDescription.reverse() : tuplasDescription;

        // set tuplas
        dataSeries.TuplasDescription.forEach((tuplaDescription) => {
          const tupla: DataTupla = dataRowSrc.getDataTupla(tuplaDescription.Name);
          if (tupla === undefined) {
            console.error('Tupla ' + tuplaDescription.Name + ' not found in row ' + dataRowSrc.Id);
          } else {
            const dataRowNew: DataRow = new DataRow();

            let tuplaNew: DataTupla;

            tuplaNew = new DataTupla();
            tuplaNew.setValue(tuplaDescription.Name, TUPLA_TYPE.STRING);
            dataRowNew.DataTuplas.push(tuplaNew);

            tuplaNew = new DataTupla();
            tuplaNew.setValue(tupla.Value, TUPLA_TYPE.NUMBER);
            tuplaNew.OutputFormat = tupla.OutputFormat;
            dataRowNew.DataTuplas.push(tuplaNew);

            dataSeries.DataRows.push(dataRowNew);
          }
        });
        datasSeries.push(dataSeries);
      });
    }

    return datasSeries;
  }

  public selectColumnsByType(columnType: TUPLA_TYPE): void {
    this.tuplasDescription.forEach(tuplaDescription => {
      if (tuplaDescription.Type === columnType) {
        tuplaDescription.selected = true;
      }
    });
  }

  public getSelectedColumns(): DataTuplaDescription[] {
    return this.tuplasDescription.filter((tuplaDescription) => {
      return tuplaDescription.selected;
    });
  }

  /**
   * get all selected row
   */
  public getSelectedRows(): DataRow[] {
    return this.DataRows.filter((row) => {
      return row.selected;
    });
  }
  /**
   * get all Ids of selected row
   */
  public getIdSelectedRows(): string[] {
    const result: string[] = [];

    this.getSelectedRows().forEach((dataRow) => {
      result.push(dataRow.Id);
    });

    return result;
  }
  public getTuplaDescription(id: string): DataTuplaDescription {
    return  this.tuplasDescription.find(x => x.Id === id);
  }

  /**
   * Flag select attribut
   * @param columnIds List of column to enable
   */
  public selectTuplaDescription(columnIds: string[]): void {
    this.tuplasDescription.forEach(tuplaDescription => {
      if (columnIds.find(x => x === tuplaDescription.Id) === undefined) {
        tuplaDescription.selected = false;
      } else {
        tuplaDescription.selected = true;
      }
    });
  }

}
